import AddressSliceType from './AddressSliceType';

const AddressInitialState: AddressSliceType = {
  provinces: {
    provincesLoading: false,
    data: [],
  },
  cities: {
    citiesLoading: false,
    data: [],
  },
};

export default AddressInitialState;
